import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

@Injectable()
export class UtilInformationService {

  constructor(public _http: HttpClient) {
  }

  getDataFromDate(ejercicio: any, semana: any): Observable<any> {
    let ruta = `${environment.getDataFromDate}${ejercicio}${
      !!semana ? '/' + semana : ''
    }`;
    return this._http.get(ruta);
  }
}
